import { render } from "./editlista.vue?vue&type=template&id=3de64f37&scoped=true"
import script from "./editlista.vue?vue&type=script&lang=js"
export * from "./editlista.vue?vue&type=script&lang=js"

import "./editlista.vue?vue&type=style&index=0&id=3de64f37&scoped=true&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de64f37"]])

export default __exports__